import React, { useCallback, useEffect } from 'react';

import {
  Panel,
  PanelFooter,
  PanelHeader,
  PanelLabel,
  PanelLink,
  PanelStatistic,
  PanelStatistics,
  PanelStatisticsFooter,
  PanelValue,
} from '../Panel/Panel';
import { Add } from '@carbon/react/icons';
import { preAssign, useFetchDeviceStatisticsQuery } from '@/redux/new_services/device';
import useModal from '@/lib/hooks/useModal';
import { useOpenDeviceWizard } from '@/lib/modal';

export const Devices = ({ small }) => {


  const handleCreateNewDevice = useOpenDeviceWizard();
  const { data, isLoading } = useFetchDeviceStatisticsQuery();

  const { count: statistic_count } = data || {};

  let label = 'Es wurden noch keine Micast-Systeme eingerichtet';

  return (
    <Panel halfSize={small}>
      <PanelHeader
        header
        helpText="Zeigt die Anzahl der eingerichteten Micast-Systeme an und bietet die Möglichkeit weitere Systeme einzurichten">
        Micast-Systeme
      </PanelHeader>

      <PanelStatistics>
        <PanelStatistic isLoading={isLoading}>
          <PanelValue>
            {statistic_count}
          </PanelValue>
          <PanelStatisticsFooter>eingerichtet</PanelStatisticsFooter>
        </PanelStatistic>
      </PanelStatistics>
      <PanelLabel semi>
        Du hast ein Micast System angeschlossen und möchtest es jetzt
        einrichten?
      </PanelLabel>
      <PanelFooter>
        <PanelLink
          onClick={() => handleCreateNewDevice()}
          icon={<Add size={32} />}>
          MICAST SYSTEM EINRICHTEN
        </PanelLink>
      </PanelFooter>
    </Panel>
  );
};
